import React from 'react';
import { useLocation } from 'react-router-dom';
import VerificationForm from '../components/Form/VerificationForm.tsx';

// Registration route for validated advisors. Only a retry of a failed attempt
// (Orders hands over the order as `prefill`) is a repeat exam; a plain
// registration books the next exam type for an existing certificate holder.
export default function ErneutePruefung() {
    const location = useLocation();
    const isRetry = !!(location.state as any)?.prefill;

    return (
        <VerificationForm
            heading={isRetry ? 'Erneute Prüfung' : 'Anmeldung zur Zentralprüfung'}
            introContentTitle="Zentralprüfung Anmeldung"
            successMessage={isRetry
                ? 'Ihre erneute Anmeldung wurde übermittelt und wird vom FPSB Deutschland geprüft. Sie erhalten eine Rückmeldung per E-Mail.'
                : undefined}
            draftKey="re-exam"
        />
    )
}
